<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
                                          <v-btn @click="onlogout">logout</v-btn>
          <v-img
              alt="Flexline logo"
              flex
              src="../assets/logo.png"
          />
          <v-divider></v-divider>
          <div class="title mt-6 font-weight-light text-center">Seamless Solutions for Running Local Services</div>

          <div class="subtitle-1  font-weight-light text-center">info@flexline.app</div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>

</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld
  },
  methods: {
    onlogout () {
      this.$store.dispatch('logout')
    },

  }
}
</script>
